import script from "./ActiveTopUpRequestsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveTopUpRequestsList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__